import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { AbstractChart } from 'containers/charts/AbstractChart';
import { labelFormatterGenerator } from 'helpers/charts';
import helpers from 'helpers';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';

class ChannelStackedBarChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        const series = [];
        const { chartRef } = this;
        const { orderedColors } = this.props.theme;
        helpers.orderedChannelKeys(this.props.enabledChannels).forEach((key, index) => {
            if (!this.props.data[key]) {
                return;
            }

            series.push({
                name: helpers.convertToDisplayValue(key),
                color: orderedColors[index % orderedColors.length],
                data: helpers.backfill(
                    this.props.data[key].map(r => ({ x: r.date_in_ms, y: r[this.props.y] })),
                    this.props.backfillBuckets
                )
            });
        });

        const xAxis = helpers.xAxisConfig({
            type: 'datetime',
            xAxisLabel: this.props.xAxisLabel
        });

        const yAxis = helpers.yAxisConfig({
            yAxisLabel: this.props.yAxisLabel || this.props.y
        });

        if (this.props.isMoney) {
            yAxis.labels = {
                formatter: labelFormatterGenerator('priceWithoutSpace')
            };
        }

        const plotOptions = {
            series: {
                animation: {
                    duration: this.props.animateDuration,
                }
            },
            [this.props.chart.type]: { stacking: 'normal', borderWidth: 0 }
        };

        return (
            <ContentTile padding={helpers.contentPadding('chart-with-legend')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{this.props.title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title
                        },
                        chart: this.props.chart,
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        credits: {
                            enabled: false
                        },
                        plotOptions,
                        title: {
                            text: null,
                        },
                        legend: {
                            itemStyle: {
                                color: this.props.theme.charts.axisAssets
                            }
                        },
                        tooltip: {
                            split: true,
                            valuePrefix: this.props.isMoney ? '$' : null,
                            valueDecimals: this.props.isMoney ? 2 : null,
                            crosshairs: {
                                width: 1,
                                color: 'gray',
                                dashStyle: 'shortdot'
                            }
                        },
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ContentTile>
        );
    }
}

ChannelStackedBarChart.propTypes = {
    data: PropTypes.object.isRequired,
    chart: PropTypes.object.isRequired,
    enabledChannels: PropTypes.array.isRequired,
    y: PropTypes.string.isRequired,
    xAxisLabel: PropTypes.string.isRequired,
    backfillBuckets: PropTypes.array.isRequired,
    animateDuration: PropTypes.number.isRequired,
    isMoney: PropTypes.bool,
    title: PropTypes.string.isRequired
};

export default withTheme(ChannelStackedBarChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/ChannelStackedChart.js